import { GuidedTourService } from '../service/guided-tour.service';
import { Directive, OnInit } from '@angular/core';
import { GuidedTour } from '../model/guided-tour';
import { Event as NavigationEvent, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive()
export abstract class GuidedTourDirective implements OnInit {
  protected guidedTour: GuidedTour;
  protected sectionNumber: number;
  protected currentStep = 0;
  protected canNavigateBack = false;

  private preventBackNavigation(): void {
    this.canNavigateBack = true;
    this.router.navigate([this.router.url], { replaceUrl: true }).then(async () => {
      this.previousTarget();
      this.clickOnTheHighlight();
      this.canNavigateBack = false;
    });
  }

  protected clickOnTheHighlight(): void {
    const prototypeElement = document.getElementById('elements-highlighter');
    if (prototypeElement) {
      prototypeElement.click();
    }
  }

  protected cleanTimeoutAndFocus(stepDelay?: number): void {
    stepDelay && clearTimeout(stepDelay);
    this.clickOnTheHighlight();
  }

  protected nextTarget(): void {
    this.currentStep++;
  }

  protected previousTarget(): void {
    this.currentStep--;
  }

  protected jumpToTarget(target: number): void {
    this.currentStep = target;
  }

  protected cancelSection(): void {
    this.currentStep = 0;
    this.guidedTourService.cancelSection();
  }

  protected async completeSection(openEndDialog: boolean): Promise<void> {
    await this.guidedTourService.completeSection(this.guidedTour.id, this.sectionNumber, openEndDialog);
  }

  protected constructor(
    guidedTour: GuidedTour,
    sectionNumber: number,
    protected guidedTourService: GuidedTourService,
    protected router: Router
  ) {
    this.sectionNumber = sectionNumber;
    this.guidedTour = guidedTour;

    this.router.events
      .pipe(
        takeUntilDestroyed(),
        filter((event: NavigationEvent): event is NavigationStart => event instanceof NavigationStart)
      )
      .subscribe((event: NavigationStart) => {
        if (event.navigationTrigger === 'popstate' && !this.canNavigateBack) {
          this.preventBackNavigation();
        }
      });
  }

  ngOnInit(): void {
    this.nextTarget();
  }
}
